import { render, staticRenderFns } from "./IntroductionMessageStep.vue?vue&type=template&id=4ee1a522&scoped=true"
import script from "./IntroductionMessageStep.vue?vue&type=script&lang=js"
export * from "./IntroductionMessageStep.vue?vue&type=script&lang=js"
import style0 from "./IntroductionMessageStep.vue?vue&type=style&index=0&id=4ee1a522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee1a522",
  null
  
)

export default component.exports